import React from 'react';
import Accordion, { AccordionItem, AccordionContent } from "../Accordion";
import PropTypes from "prop-types";
const AccordionWrap = ({sambutan}) => {
    return (
        <div className="agency-accordion max-mb-n30">
            <Accordion>
                <AccordionItem id="one">
                    <AccordionContent id="one">{sambutan}</AccordionContent>
                </AccordionItem>
                {/* <AccordionItem id="two">
                    <AccordionTitle id="two">What’s the branding process like?</AccordionTitle>
                    <AccordionContent id="two">Branding is more than a logo and a clever tagline. Your brand tells the story of your company. It’s your message and your values. When that happens, remarkable things occur.</AccordionContent>
                </AccordionItem>
                <AccordionItem id="three">
                    <AccordionTitle id="three">What type of creative services do you offer?</AccordionTitle>
                    <AccordionContent id="three">Branding is more than a logo and a clever tagline. Your brand tells the story of your company. It’s your message and your values. When that happens, remarkable things occur.</AccordionContent>
                </AccordionItem> */}
            </Accordion>
        </div>
    )
}

AccordionWrap.propTypes = {
    sambutan: PropTypes.string
};

export default AccordionWrap;
